/* Core & libraries */
import * as React from "react";
import { useTheme } from "react-jss";

/* Helpers, constants, custom methods, internal libraries */
import { useGetGuestProfiles } from '../../hooks/useGetGuestProfiles';

/* Components */
import PeoplePageHeader from "../../components/peoplePageHeader";
import PeopleTabbedNav from "../../components/peopleTabbedNav";
import { useTeamService } from '../../services/teamService';


/* Styles */
import styles from "./styles";


const People = () => {
  const theme = useTheme();
  const classes = styles({ theme });

  const { teamsResponse, getTeamsList, deleteTeam } = useTeamService();
  const { guestProfiles, getGuestProfilesAction } = useGetGuestProfiles();

  return (
    <div className={ classes.peoplePage }>
      <PeoplePageHeader getTeamsList={getTeamsList} getGuestProfilesAction={getGuestProfilesAction}/>
      <PeopleTabbedNav
        getTeamsList={getTeamsList}
        teamsResponse={teamsResponse}
        deleteTeam={deleteTeam}
        guestProfiles={guestProfiles}
        getGuestProfilesAction={getGuestProfilesAction}
      />
    </div>
  )
}

export default People;
